'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('style-inject');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styleInject__default = /*#__PURE__*/_interopDefaultLegacy(styleInject);

var css_248z = ".Column-module_column__ihEsE{display:grid;grid-template-columns:repeat(12,[col-start] 1fr);grid-column-gap:.5rem;-moz-column-gap:.5rem;column-gap:.5rem;grid-auto-rows:min-content}";
var styles = {"column":"Column-module_column__ihEsE"};
styleInject__default["default"](css_248z);

exports["default"] = styles;
